export default angular
  .module("AliasScriptRelationCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("AliasScriptRelationController", [
    "$scope",
    "$stateParams",
    "$rootScope",
    "$location",
    "Scripts",
    "System",
    function (
      $scope,
      $stateParams,
      $rootScope,
      $location,
      Scripts,
    ) {
      $scope.isScriptShow = false;

      const aliasId = $stateParams.id;
      if (aliasId) {
        Scripts.loadCodeAliasScripts(aliasId, (scripts) => {
          $scope.aliasScripts = scripts;
        });
      }

      $scope.openScriptURL = function (scriptID) {
        $rootScope.searchString = $scope.searchString;
        $location.path(`/script/${scriptID}`);
      };
    },
  ]);
